var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotesSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15625 11.0938H9.84375V10.1562H5.15625V11.0938ZM5.15625 8.59375H9.84375V7.65625H5.15625V8.59375ZM3.94234 13.4375C3.62661 13.4375 3.35938 13.3281 3.14062 13.1094C2.92188 12.8906 2.8125 12.6234 2.8125 12.3077V2.69234C2.8125 2.37661 2.92188 2.10938 3.14062 1.89062C3.35938 1.67188 3.62661 1.5625 3.94234 1.5625H8.90625L12.1875 4.84375V12.3077C12.1875 12.6234 12.0781 12.8906 11.8594 13.1094C11.6406 13.3281 11.3734 13.4375 11.0577 13.4375H3.94234ZM8.4375 5.3125V2.5H3.94234C3.89422 2.5 3.85016 2.52005 3.81016 2.56016C3.77005 2.60016 3.75 2.64422 3.75 2.69234V12.3077C3.75 12.3558 3.77005 12.3998 3.81016 12.4398C3.85016 12.4799 3.89422 12.5 3.94234 12.5H11.0577C11.1058 12.5 11.1498 12.4799 11.1898 12.4398C11.2299 12.3998 11.25 12.3558 11.25 12.3077V5.3125H8.4375Z",
    fill: "#7E8392"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesSmall);
export default __webpack_public_path__ + "static/media/notes-small.4c2e10eb84f6501b29d78cdc8ebaaa21.svg";
export { ForwardRef as ReactComponent };